import COM from './Asset'

export default COM
